@if ({user: activeUser$ | async, routerUrl: routerUrl$ | async}; as state) {
  <navbar-item
    [matMenuTriggerFor]="userOptionsMenu"
    [isAvatarItem]="true"
    [user]="state.user"
    [item]="{display: state.user?.username}"
    [isAvatarItem]="true"
    [selected]="state.routerUrl === profileUrl"
  />

  <mat-menu #userOptionsMenu="matMenu" xPosition="before" yPosition="above" class="oph-user-select-menu">
    <ng-content select=".user-options-selector" />
  </mat-menu>
}
